import { pubsub } from './pubsub';
import Projects from './projects';
import Tasks from './tasksfactory';
import { displayAllTasksOnClick } from './homepage-ui';
import { isToday } from "date-fns";
import { isThisWeek } from "date-fns";

// adds a project to local storage
export function addProjectToLocalStorage() {
	pubsub.subscribe('projectAdded', saveProjectToLocalStorage);
}

function saveProjectToLocalStorage(name) {
	const newProject = Projects({ name: name });

	// Retrieve existing items from local storage or initialize an empty array
	const existingItems = JSON.parse(localStorage.getItem('todoItems')) || [];
	// Add the new item to the array
	existingItems.push(newProject);
	// Save the updated array back to local storage
	localStorage.setItem('todoItems', JSON.stringify(existingItems));

	// publishing the list of projects that are stored in localStorage
	const inLocalStorage =  JSON.parse(localStorage.getItem('todoItems')) || [];
	pubsub.publish('projectsStored', inLocalStorage);
}

// retrieves all of the projects in local storage
// used to display list of projects on page load
export function retrieveLocalStorage() {
	// publishing the list of projects that are stored in localStorage
	const inLocalStorage =  JSON.parse(localStorage.getItem('todoItems')) || [];
	pubsub.publish('projectsStored', inLocalStorage);
}

// delete a project
export function processProjectDelete() {
	pubsub.subscribe('projectDeleted', deleteProject);
}

function deleteProject(index) {
	// Retrieve items from local storage
	const storedItems = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Find the index of the item to delete
	const indexOfItemToDelete = storedItems.findIndex(item => item.projectId === index);

	// Check if the item was found
	if (indexOfItemToDelete !== -1) {
		// Remove the item from the array
		storedItems.splice(indexOfItemToDelete, 1);

		// Save the updated array back to local storage
		localStorage.setItem('todoItems', JSON.stringify(storedItems));

		// Log the updated list (optional)
		console.log('Updated todo items:', storedItems);

		// publishing the list of projects that are stored in localStorage
		const inLocalStorage =  JSON.parse(localStorage.getItem('todoItems')) || [];
		pubsub.publish('projectsStored', inLocalStorage);
		// re-render the list of tasks to show all tasks
		// without the tasks of the deleted project
		displayAllTasksOnClick();
	} else {
		console.log('Item not found for deletion.');
	}
}

// adds a task to local storage
export function processTaskAdded() {
	pubsub.subscribe('taskAdded', addTaskToLocalStorage);
}

function addTaskToLocalStorage(info) {
	// getting existing items
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// find the matching project
	const projectToUpdate = existingProjects.find(project => project.projectId === info.index);

	if (projectToUpdate) {
		// creating a task with the factory function
		const newTask = Tasks({
			projectId: info.index,
			title: info.name,
			description: info.details,
			duedate: info.date,
			priority: info.priority,
			done: info.completed
		});

		// adding the task to the project's task array
		projectToUpdate.tasks.push(newTask);

		// Save the updated projects array back to local storage
		localStorage.setItem('todoItems', JSON.stringify(existingProjects));

		// publish event that task is stored
		pubsub.publish('taskStored', projectToUpdate.tasks);
	}
}

// sends back to the UI the project that was selected in the sidebar
export function projectSelected() {
	pubsub.subscribe('projectSelected', retrieveSelectedProject);
}

function retrieveSelectedProject(info) {
	// Retrieve existing projects from local storage or initialize an empty array
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Find the project by its ID
	const selectedProject = existingProjects.find(project => project.projectId === info.index);
	pubsub.publish('returnSelectedProject', selectedProject);
}

// changes the status of task - done / not done, in local storage
export function processChangeTaskStatus() {
	pubsub.subscribe('changeTaskStatus', changeStatus);
}

function changeStatus(object) {
	// retrieve existing projects
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// find out the task with the specified Id
	for (const project of existingProjects) {
		const taskToUpdate = project.tasks.find(task => task.taskId === object.index);

		if (taskToUpdate) {
			taskToUpdate.done = object.done;
			localStorage.setItem('todoItems', JSON.stringify(existingProjects));
			break;
		}
	}
}

// changes the due date of a task, in local storage
export function processChangeTaskDate() {
	pubsub.subscribe('changeTaskDate', changeDate);
}

function changeDate(object) {
	// retrieve existing projects
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// find out the task with the specified Id
	for (const project of existingProjects) {
		const taskToUpdate = project.tasks.find(task => task.taskId === object.index);

		if (taskToUpdate) {
			taskToUpdate.duedate = object.date;
			localStorage.setItem('todoItems', JSON.stringify(existingProjects));
			break;
		}
	}
}

// send back to the UI the task info needed to be diplayed in the info modal
export function processTaskDetailsModal() {
	pubsub.subscribe('findTaskInfo', processTaskInfo);
}

function processTaskInfo(index) {
	// retrieve existing projects
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// find out the task with the specified Id
	for (const project of existingProjects) {
		const taskToRetrieve = project.tasks.find(task => task.taskId === index);
		if (taskToRetrieve) {
			// get the project name for task info modal
			const projectName = project.name;

			const taskInfo = {
				name: taskToRetrieve.title,
				description: taskToRetrieve.description,
				date: taskToRetrieve.duedate,
				priority: taskToRetrieve.priority,
				done: taskToRetrieve.done,
				projectId: taskToRetrieve.projectId,
				projectName: projectName,
				taskId: taskToRetrieve.taskId,
			}
			pubsub.publish('taskInfoForModal', taskInfo);
		}
	}
}

// part of the process of editing a task from the task edit button
// event flow: tasks-render > local-storage(this step) > tasks-form > local-storage > homepage-ui
export function processOpenPrefilledTaskModal() {
	pubsub.subscribe('openPrefilledTaskModal', getTaskInfo);
}

function getTaskInfo(index) {
	// retrieve existing projects
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// find out the task with the specified Id
	for (const project of existingProjects) {
		const taskToRetrieve = project.tasks.find(task => task.taskId === index);

		if (taskToRetrieve) {
			// get the project name for task info modal
			const projectName = project.name;

			const taskInfo = {
				name: taskToRetrieve.title,
				description: taskToRetrieve.description,
				date: taskToRetrieve.duedate,
				priority: taskToRetrieve.priority,
				done: taskToRetrieve.done,
				projectId: taskToRetrieve.projectId,
				projectName: projectName,
				taskId: taskToRetrieve.taskId,
			}
			pubsub.publish('taskInfoForEditModal', taskInfo);
		}
	}
}

// part of the process of editing a task from the task edit button
// event flow: tasks-render > local-storage > tasks-form > local-storage(this step) > homepage-ui
export function processTaskEdited() {
	pubsub.subscribe('taskEdited', saveEditedTask);
}

function saveEditedTask(object) {
	// get existing projects from local storage
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Find the project by its ID
	const projectToUpdate = existingProjects.find(project => project.projectId === object.projectId);

	// update the project's task if the project id found
	if (projectToUpdate) {
		// find the task using its ID
		const taskToUpdate = projectToUpdate.tasks.find(task => task.taskId === object.taskId);

		// if the task is found, assign the object to it
		if (taskToUpdate) {
			Object.assign(taskToUpdate, object);

			// Save the updated projects array back to local storage
			localStorage.setItem('todoItems', JSON.stringify(existingProjects));

			// send back the edited list of project tasks to be diplayed in the UI
			pubsub.publish('taskStored', projectToUpdate.tasks);
		} else {
			console.log(`The task with ID ${object.taskId} not found in the project with ID ${object.projectId}`);
		}
	} else {
		console.log(`The project with ID ${object.projectId} was not found`);
	}
}

// response from task-render to delete a task
// part of the flow of deleting a task from the delete task button
export function processDeleteTaskRequest() {
	pubsub.subscribe('deleteTaskRequest', deleteTask);
}

function deleteTask(index) {
	// retrieve existing projects
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// find out the task to be deleted based on ID
	for (const projectToUpdate of existingProjects) {
		const taskToDelete = projectToUpdate.tasks.findIndex(task => task.taskId === index);

		// check if task is found, and if true, then delete it
		if (taskToDelete !== -1) {
			// remove the task from the array
			projectToUpdate.tasks.splice(taskToDelete, 1);

			// save the projects array back to local storage
			localStorage.setItem('todoItems', JSON.stringify(existingProjects));

			// boardcast event to refresh the list of existing project tasks
			pubsub.publish('taskStored', projectToUpdate.tasks);

			return;
		}
	}
	// if the task was not found, return a console message
	  console.log(`Task with ID ${index} not found in any project`);
}

// retrieve tasks for the homepage ui to dipsplay
// at pageload or when the 'All Tasks' filter is clicked
export function processRequestAllTasksStored() {
	pubsub.subscribe('requestAllTasksStored', getAllTasksStored);
}

function getAllTasksStored() {
	// Retrieve projects from local storage
	const storedProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Array to store all tasks
	let allTasks = [];

	// Iterate over each project
	storedProjects.forEach(project => {
		// Check if the project has tasks
		if (project.tasks && project.tasks.length > 0) {
			// Add tasks of the current project to allTasks array
			allTasks = allTasks.concat(project.tasks);
		}
	});

	// sort the array based on the priority of tasks
	// it sorts the original array in descending order
	allTasks.sort(function(a, b) {
		return parseInt(b.priority) - parseInt(a.priority);
	});

	// crate a new array for all the tasks minus the ones marked as 'done'
	const allTasksButDone = allTasks.filter(filterByNotDone);

	// use the existing 'taskStored' to fill
	// the main content area with the list of tsks
	pubsub.publish('tasksFiltered', allTasksButDone);
}

// function to send Important tasks to the UI
export function processRequestImportantTasks() {
	pubsub.subscribe('requestImportantTasks', retrieveImportantTasks);
}

function retrieveImportantTasks() {
	// Retrieve projects from local storage
	const storedProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Array to store all tasks
	let allTasks = [];

	// Iterate over each project
	storedProjects.forEach(project => {
		// Check if the project has tasks
		if (project.tasks && project.tasks.length > 0) {
			// Add tasks of the current project to allTasks array
			allTasks = allTasks.concat(project.tasks);
		}
	});

	// create a new array just with important tasks
	const importantTasks = allTasks.filter(filterByPriority);
	// filter the important tasks so that
	// only the ones not marked as 'done' show
	const importantTasksNotDone = importantTasks.filter(filterByNotDone);
	pubsub.publish('tasksFiltered', importantTasksNotDone);
}

function filterByPriority(item) {
	if (item.priority && item.priority === '3') {
		return true;
	}
	return false;
}

// retrieve Today's tasks
export function processRequestTodaysTasks() {
	pubsub.subscribe('requestTodaysTasks', getTodaysTasks);
}

function getTodaysTasks() {
	// Retrieve projects from local storage
	const storedProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Array to store all tasks
	let allTasks = [];

	// Iterate over each project
	storedProjects.forEach(project => {
		// Check if the project has tasks
		if (project.tasks && project.tasks.length > 0) {
			// Add tasks of the current project to allTasks array
			allTasks = allTasks.concat(project.tasks);
		}
	});
	const todaysTasks = allTasks.filter(filterByTodaysDate);
	// filter todaysTasks and show only
	// the ones not marked as 'done'
	const todaysTasksNotDone = todaysTasks.filter(filterByNotDone);
	pubsub.publish('tasksFiltered', todaysTasksNotDone);
}

function filterByTodaysDate(item) {
	// get today's date and format it with date-fns
	const today = isToday(new Date());

	// check the item's date-fns formated duedate against 'today'
	if (item.duedate && isToday(item.duedate) === today) {
		return true;
	}
	return false;
}

// retrive the tasks for the current week
export function processRequestWeekTasks() {
	pubsub.subscribe('requestWeekTasks', getWeekTasks);
}

function getWeekTasks() {
	// Retrieve projects from local storage
	const storedProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// Array to store all tasks
	let allTasks = [];

	// Iterate over each project
	storedProjects.forEach(project => {
		// Check if the project has tasks
		if (project.tasks && project.tasks.length > 0) {
			// Add tasks of the current project to allTasks array
			allTasks = allTasks.concat(project.tasks);
		}
	});
	const thisWeekTasks = allTasks.filter(filterByWeek);
	// filter out the tasks marked as 'done'
	const thisWeekTasksNotDone = thisWeekTasks.filter(filterByNotDone);
	pubsub.publish('tasksFiltered', thisWeekTasksNotDone);
}

function filterByWeek(item) {
	const thisWeek = isThisWeek(new Date());

	if (item.duedate && isThisWeek(item.duedate) === thisWeek) {
		return true;
	}
	return false;
}

function filterByDone(item) {
	// return the items that are marked as done
	if (item.done && item.done === true) {
		return true;
	}
	return false;
}

// this works with all other filters
// to show only the tasks not marked as 'done'
function filterByNotDone(item) {
	// return the items that are NOT marked as done
	return !item.done;
}
